import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_bottom_g",
  "use": "icon-arrow_bottom_g-usage",
  "viewBox": "0 0 33 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 33 19\" id=\"icon-arrow_bottom_g\">\n    <path stroke=\"currentColor\" stroke-width=\"3\" d=\"M31 2L16.5 16 2 2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol